<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="detail-popup">
      <div class="popup-header">
        <div class="popup_title">계약이력</div>
        <img src="@/assets/images/close_btn.png" @click="confirmSelection(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="contents_body">
          <!-- 계약이력 테이블 -->
          <table class="contract_table">
            <thead>
              <tr>
                <th>등록일시</th>
                <th>파일명</th>
                <th>비고</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in contractList" :key="index">
                <td>{{ convertDateTime(item.등록일시) }}</td>
                <td>{{ item.저장파일.원파일명 }}</td>
                <td>{{ item.비고 }}</td>
                <td @click="readContract(item)">{{ item[`${props.회원구분}계약서작성여부`] ? '보기' : '날인'}}</td>
                <td @click="deleteContract(item)">{{ item.수주계약서작성여부 && item.수행계약서작성여부 ? '' : '삭제'}}</td>
              </tr>
              <tr v-if="contractList.length === 0">
                <td colspan="5">등록된 계약이력이 없습니다.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="popup-footer">
        <div class="popup_confirm_btn" @click="confirmSelection(true)">{{contractList.length === 0 ? '최초':'변경'}}계약 등록</div>
      </div>
    </div>
  </div>
  <UploadContractPop v-if="uploadContractFlag" @closePopup="uploadContractClose" :공고순번="props.공고순번" />
</template>

<script setup lang="ts">
// ...existing code...
import { ref, onMounted, defineEmits, defineProps } from 'vue';

import UploadContractPop from '@/components/popup/UploadContractPop.vue';
import announceAPI from '@/api/announceAPI';
import { Contract, saveFile } from "@/common/types";
import { convertDateTime } from '@/utils/utils';

const emit = defineEmits(["closePopup","openContractPop"]);
const uploadContractFlag = ref(false);
const uploadContractClose = () => {
  uploadContractFlag.value = false;
  getContractList()
}
// 예시 데이터
const props = defineProps<{
  공고순번: number;
  회원구분: string;
}>();
const contractList = ref<Contract[]>([
  {
    계약서순번: 1,
    수주계약서작성여부: true,
    수행계약서작성여부: true,
    저장파일: {} as saveFile,
    작성일시: ''
  },
  {
    계약서순번: 1,
    수주계약서작성여부: true,
    수행계약서작성여부: true,
    저장파일: {} as saveFile,
    작성일시: ''
  }
]);
onMounted(() => {
  getContractList()
});
const getContractList = async () => {
  await announceAPI.contractList(props.공고순번).then((res) => {
    contractList.value = res.data.data;
  });
};
const readContract = (data: Contract) => {
  emit("openContractPop", data);
};
const confirmSelection = (flag: boolean) => {
  if(flag) {
    uploadContractFlag.value = true
  } else {
    emit("closePopup", { popupType: "contractList", refresh: flag });
  }
};
const deleteContract = async (data: Contract) => {
  if(data.수주계약서작성여부 && data.수행계약서작성여부) return;
  if (!confirm("작성중인 계약서를 삭제하시겠습니까?")) return;
  await announceAPI.deleteContract(props.공고순번, data.계약서순번).then(() => {
    alert("계약서가 삭제되었습니다.");
    getContractList()
  });
}
// ...existing code...
</script>

<style scoped>

.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.detail-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 800px;
  height: calc(50% - 36px);
  background: white;
  top: calc(50% - 245px);
  left: calc(50% - 400px);
  border-radius: 11px;
}
.contrainer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
}
.cover {
  background: #000;
  opacity: 0.3;
  width: 100%;
  height: 100%;
  position: absolute;
}
.contract_table {
  width: 100%;
  border-collapse: separate;  /* collapse에서 separate로 변경 */
  border-spacing: 0;          /* 셀 간격 없애기 */
  border-radius: 6px;         /* 테이블 전체에 radius 적용 */
  overflow: hidden;           /* 내부 요소가 radius를 넘지 않도록 */
  border: 1px solid #ccc;
}

.contract_table th,
.contract_table td {
  padding: 8px;
  text-align: center;
  border: 1px solid #ccc;
}
.contract_table th {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  color: #272727;
  background-color: #f6f7fb;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 20px 40px;
  height: calc(100% - 127px);
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0px 40px;
  gap: 10px;
}
.close_icon {
  cursor: pointer;
}

.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #282b33;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
  background: #3382e9;
  color: #fff;
}
.contract_table > tbody > tr > td:nth-child(4) {
  cursor: pointer;
}
.contract_table > tbody > tr > td:nth-child(5) {
  cursor: pointer;
  font-weight: 900;
}
</style>